import script from "./finish.vue?vue&type=script&setup=true&lang=js"
export * from "./finish.vue?vue&type=script&setup=true&lang=js"

import "./finish.vue?vue&type=style&index=0&id=6c437aa0&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c437aa0"]])

export default __exports__